/* eslint-disable camelcase */
import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';
import React, { useEffect, useState } from 'react';

import { cookieConsentReady } from 'components/CookieConsent';

import {
  adzunaScript,
  facebookScript,
  googleAdwordsScript,
  googleAnalytics4Script,
  googleScript,
  googleTagManagerHTMLScript,
  perengoScript,
  recruiticsScript,
} from './scripts';
import { TrackerJs } from './TrackerJs';

export function scriptHandler(tracker: ConversionTracker): {
  script?: string;
  location?: 'body' | 'head';
  trackerName?: string;
  forceHeadOnly?: boolean;
} {
  const { custom_javascript, provider, name: trackerName } = tracker;

  switch (provider) {
    case 'adzuna':
      return {
        script: adzunaScript(tracker),
        location: 'body',
        trackerName,
      };
    case 'facebook':
      return {
        script: facebookScript(tracker),
        location: 'head',
        trackerName,
      };
    case 'perengo':
      return {
        script: perengoScript(tracker),
        location: 'head',
        trackerName,
      };
    case 'recruitics':
      return {
        script: recruiticsScript(),
        location: 'body',
        trackerName,
      };
    case 'google':
      return {
        script: googleScript(tracker),
        location: 'head',
        trackerName,
      };
    case 'google_analytics_4':
      return {
        script: googleAnalytics4Script(tracker),
        location: 'head',
        trackerName,
      };
    case 'google_adwords':
      return {
        script: googleAdwordsScript(tracker),
        location: 'body',
        trackerName,
      };
    case 'google_tag_manager':
      return {
        script: googleTagManagerHTMLScript(tracker),
        location: 'head',
        trackerName,
        forceHeadOnly: true,
      };
    case 'custom':
      return {
        script: custom_javascript,
        location: 'body',
        trackerName,
      };
    default:
      return {
        script: undefined,
        location: undefined,
      };
  }
}

export interface ConversionTrackingProps {
  tracker: ConversionTracker;
}

export const ConversionTracking: React.VFC<ConversionTrackingProps> = ({
  tracker,
}) => {
  const { script, location, trackerName, forceHeadOnly } =
    scriptHandler(tracker);
  const [permission, setPermission] = useState(false);

  useEffect(() => {
    cookieConsentReady()
      .then(() => {
        setPermission(true);
      })
      .catch(
        /* istanbul ignore next -- Just error logging */
        // eslint-disable-next-line no-console
        e => console.error(e),
      );
  }, []);

  return (
    <>
      {permission && (
        <TrackerJs
          customJs={script}
          location={location}
          trackerName={trackerName}
          forceHeadOnly={forceHeadOnly}
        />
      )}
    </>
  );
};
